import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { useMapValidator } from './useMapValidator.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { MechanicValidatorShipMove } from '@colonist/game-mechanic-validators';
export const useMechanicValidatorShipMove = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicShipState = useGameStore((state)=>state.gameState.mechanicShipState);
    const mechanicPirateState = useGameStore((state)=>state.gameState.mechanicPirateState);
    return useMemo(()=>{
        if (!mechanicShipState) return undefined;
        return new MechanicValidatorShipMove(playerValidators, mapValidator, mechanicShipState, mechanicPirateState);
    }, [
        playerValidators,
        mapValidator,
        mechanicShipState,
        mechanicPirateState
    ]);
};
